import { createStructuredSelector } from "reselect";
import {
    DOSAGE_FORM_GROUP_LIST,
    DOSAGE_FORM_GROUP_LIST_SUCCESS,
    DOSAGE_FORM_GROUP_LIST_ERROR,
    DOSAGE_FORM_GROUP_PAGE_SET,
    DOSAGE_FORM_GROUP_HEADER,
    DOSAGE_FORM_GROUP_SEARCH_SET,
    DOSAGE_FORM_GROUP_SEARCH_CHANGE,
    DOSAGE_FORM_GROUP_ADD_SET,
    DOSAGE_FORM_GROUP_ADD_MODAL_SET,
    DOSAGE_FORM_GROUP_ADD,
    DOSAGE_FORM_GROUP_ADD_SUCCESS,
    DOSAGE_FORM_GROUP_ADD_ERROR,
    DOSAGE_FORM_GROUP_ADD_CHANGE,
    DOSAGE_FORM_GROUP_EDIT_SET,
    DOSAGE_FORM_GROUP_EDIT_CHANGE,
    DOSAGE_FORM_GROUP_EDIT_MODAL_SET,
    DOSAGE_FORM_GROUP_DETAIL,
    DOSAGE_FORM_GROUP_DETAIL_SUCCESS,
    DOSAGE_FORM_GROUP_DETAIL_ERROR,
    DOSAGE_FORM_GROUP_UPDATE,
    DOSAGE_FORM_GROUP_UPDATE_SUCCESS,
    DOSAGE_FORM_GROUP_UPDATE_ERROR
} from "../actions";

export const NAME = 'dosageFormGroup';

export const DosageFormGroupList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: DOSAGE_FORM_GROUP_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const DosageFormGroupListSuccess = (data) => ({
    type: DOSAGE_FORM_GROUP_LIST_SUCCESS,
    payload: data
});

export const DosageFormGroupListError = (error) => ({
    type: DOSAGE_FORM_GROUP_LIST_ERROR,
    payload: error
});

export const DosageFormGroupPageSet = (data) => ({
    type: DOSAGE_FORM_GROUP_PAGE_SET,
    payload: data
});

export const DosageFormGroupHeader = (data) => ({
    type: DOSAGE_FORM_GROUP_HEADER,
    payload: data
})

export const DosageFormGroupSearchSet = (data) => ({
    type: DOSAGE_FORM_GROUP_SEARCH_SET,
    payload: data
});

export const DosageFormGroupSearchChangeSet = (data) => ({
    type: DOSAGE_FORM_GROUP_SEARCH_CHANGE,
    payload: data
});


export const DosageFormGroupAddChangeSet = (data) => ({
    type: DOSAGE_FORM_GROUP_ADD_CHANGE,
    payload: data
});

export const DosageFormGroupAddSet = (data) => ({
    type: DOSAGE_FORM_GROUP_ADD_SET,
    payload: data
});

export const DosageFormGroupAddModalSet = (data) => ({
    type: DOSAGE_FORM_GROUP_ADD_MODAL_SET,
    payload: data
});

export const DosageFormGroupAdd = (data) => ({
    type: DOSAGE_FORM_GROUP_ADD,
    payload: data
});

export const DosageFormGroupAddSuccess = (message) => ({
    type: DOSAGE_FORM_GROUP_ADD_SUCCESS,
    payload: message
});

export const DosageFormGroupAddError = (error) => ({
    type: DOSAGE_FORM_GROUP_ADD_ERROR,
    payload: error
});

export const DosageFormGroupEditSet = (data) => ({
    type: DOSAGE_FORM_GROUP_EDIT_SET,
    payload: data
});

export const DosageFormGroupEditChangeSet = (data) => ({
    type: DOSAGE_FORM_GROUP_EDIT_CHANGE,
    payload: data
});

export const DosageFormGroupEditModalSet = (data) => ({
    type: DOSAGE_FORM_GROUP_EDIT_MODAL_SET,
    payload: data
});

export const DosageFormGroupEditTabSet = (data) => ({
    type: DOSAGE_FORM_GROUP_EDIT_TAB_SET,
    payload: data
});

export const DosageFormGroupDetail = (data) => ({
    type: DOSAGE_FORM_GROUP_DETAIL,
    payload: data
});

export const DosageFormGroupDetailSuccess = (data) => ({
    type: DOSAGE_FORM_GROUP_DETAIL_SUCCESS,
    payload: data
});

export const DosageFormGroupDetailError = (error) => ({
    type: DOSAGE_FORM_GROUP_DETAIL_ERROR,
    payload: error
});

export const DosageFormGroupUpdate = (data) => ({
    type: DOSAGE_FORM_GROUP_UPDATE,
    payload: data
});

export const DosageFormGroupUpdateSuccess = (message) => ({
    type: DOSAGE_FORM_GROUP_UPDATE_SUCCESS,
    payload: message
});

export const DosageFormGroupUpdateError = (error) => ({
    type: DOSAGE_FORM_GROUP_UPDATE_ERROR,
    payload: error
});



const dosageFormGroup = (state) => state[NAME];

export const DosageFormGroupSelector = createStructuredSelector({
    dosageFormGroup
})
